import {AxiosResponse} from 'axios'
import Client from 'core/api/client'
import {IanaTimezone} from 'core/utils/timezone'
import authHeaders from './authHeaders'
import { IStudyReviewerResult } from './getStudyReviewer'

interface IGetTechnicianPhysiciansResponseBody {
  physicians: IStudyReviewerResult[]
}

export interface IGetTechnicianPhysiciansResponse extends AxiosResponse {
  data: IGetTechnicianPhysiciansResponseBody
}

export function getTechnicianPhysicians(token: string, technicianId: string): Promise<IGetTechnicianPhysiciansResponse> {
  const url = `/study/technicians/${technicianId}/physicians`;
  return Client.get(url, { ...authHeaders(token), validateStatus: () => true });
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_reviewer/getTechnicianPhysicians.ts